var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-container',{staticClass:"text-xs-center"},[_c('h1',[_vm._v("Access Denied")]),_c('p',[_vm._v("You are not authorized to view this page")]),_c('p',[_vm._v("If you are a new user, you may not have been given permissions to view any pages yet.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }